angular.module('bbl.common')
	.factory('CallManager', [
		'Auth', 'pubsub', 'JsSIP', 'PlivoService', 'TenyxRTC', '$timeout', '$window', '$interval', 'gtmJS', '$q', 'Toast', CallManagerFactory]);

var types = {
	NEWCALL: 'cm.new-call',
};

function CallManagerFactory(Auth, pubsub, JsSIP, Plivo, TenyxRTC, $timeout, $window, $interval, gtmJS, $q, Toast) {
	var providers = {
		fs: JsSIP,
		plivo: Plivo,
    'node-cc': TenyxRTC,
	};

  var CONFIG = {};
	var config = function(username, password) {
		angular.extend(CONFIG, {username: username, password: password});
	};

	Auth.getUserInfo().then(function(data) {
		config(data.plivo_username, data.plivo_password);
	}).catch(angular.noop);

	pubsub.sub(Auth.evTypes.LOGGED_IN, function(ev, data) {
		config(data.plivo_username, data.plivo_password);
	});


	var format = function(duration) {
		var format = duration > 3600*1000 ? 'HH:mm:ss' : 'mm:ss';
		return moment(duration).format(format);
	};

	var call;

	return {
		init: config,

		types: types,
		sub: pubsub.sub.bind(pubsub),

		getCall: function() { return call; },

		createCall: function(bridge) {
      // JUST FOR ANALYTICS
      // send a `FIRST_CALL` event if no minutes were used, and account created < 30 days
      Auth.getUserInfo().then(function(data) {
        var c = data.company;
        var minutesUsed = c.minutes_in_package - c.minutes_left;
        var daysFromCreated = (Date.now() - new Date(c.created)) / (24 * 3600 * 1000);

        if (minutesUsed === 0 && daysFromCreated <= 30) {
          gtmJS.push(gtmJS.events.FIRST_CALL);
        }
      });

			if(typeof bridge === 'string') {
				bridge = {bridge_number: bridge, service_provider: 'fs'};
			}

      var Provider = providers[bridge.service_provider || 'fs'] || providers.plivo;
      var jfb_url = (bridge.jfb_url || '').replace(/(https?\:\/\/)|(\/$)/ig, '');

      if (jfb_url) {
        jfb_url += ':7443';
      }

			$q.when(Provider.init(CONFIG))
        .then(onProviderReady);

      call = {
        startTime: 0,
        connected: false,
        isMute: false,
        duration: format(0),
        bridge: angular.copy(bridge),
      };

      function onProviderReady() {
        var intv;

        angular.extend(call, Provider.makeCall(bridge.bridge_number, jfb_url));

        call.on(call.types.ANSWERED, function() {
          call.startTime = +new Date();
          call.connected = true;

          $window.onbeforeunload = function(){
            return 'Leaving this page will disconnect the call!';
          };

          intv = $interval(function(){
            if (!call) {
              $interval.cancel(intv);
              return;
            }
            call.duration = format(+new Date() - call.startTime);
          }, 1000);
        });

        call.on(call.types.TERMINATED, function() {
          if (call) {
            $interval.cancel(intv);
            $window.onbeforeunload = undefined;
          }

          call = null;
        });

        pubsub.pub(types.NEWCALL, call);
      }

			return call;
		},
	};
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/call-manager-service.js
 ** module id = 292
 ** module chunks = 0
 **/